module.exports = __webpack_public_path__ + "assets/icon-codeable-logo.cccbba3d.svg";